export default __webpack_public_path__ + "static/media/news-4.2f10f864.jpg";